export default "__VITE_ASSET__Nq6WDCb0__"